import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../../../../../VisualAssets/IconV3/index.js';
import { IconV3 as IconV3Memoized } from '../../../../../../VisualAssets/IconV3/Icon.js';

var SingleSelectionListItem = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    listItemProps = props.listItemProps,
    isSelected = props.isSelected;
  return /*#__PURE__*/React.createElement("li", _extends({}, listItemProps, {
    ref: ref
  }), children, isSelected && /*#__PURE__*/React.createElement(IconV3Memoized, {
    iconId: "fill.symbol.check",
    staticSize: "24",
    color: "product.primary"
  }));
}));

export { SingleSelectionListItem };
//# sourceMappingURL=SingleSelectionListItem.js.map
